module.exports = __webpack_public_path__ + "img/ring_0_0_null_0@3x.cf8bd6fe.png";